import { createContext, useReducer, useEffect } from 'react';
import { clearSession, clearSessionId, getAccessToken } from '../utils/storage';
import { getProfile } from '../api/authApi';

const AuthContext = createContext();

const authReducer = (state, action) => {
    switch (action.type) {
        case 'LOGIN':
            return {
                ...state,
                user: action.payload.user,
                token: action.payload.token,
                isAuthenticated: true,
                isLoading: false
            };
        case 'LOGOUT':
            clearSession();
            clearSessionId();
            return {
                ...state,
                user: null,
                token: null,
                isAuthenticated: false,
                isLoading: false
            };
        case 'SET_LOADING':
            return {
                ...state,
                isLoading: action.payload
            };
        case 'UPDATE_USER':
            return {
                ...state,
                user: action.payload
            };
        default:
            return state;
    }
};

export const AuthProvider = ({ children }) => {
    const [state, dispatch] = useReducer(authReducer, {
        user: null,
        token: null,
        isAuthenticated: false,
        isLoading: true,
    });

    useEffect(() => {
        const initializeAuth = async () => {
            const token = getAccessToken();
            if (!token) {
                dispatch({ type: 'SET_LOADING', payload: false });
                return;
            }

            try {
                const response = await getProfile();
                if (response.status === 'success') {
                    dispatch({
                        type: 'LOGIN',
                        payload: {
                            user: response.data.user,
                            token: token
                        }
                    });
                } else {
                    console.log(response);
                    dispatch({ type: 'LOGOUT' });
                }
            } catch (error) {
                dispatch({ type: 'LOGOUT' });
            }
        };

        initializeAuth();
    }, []);

    return (
        <AuthContext.Provider value={{ state, dispatch }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;
